import React from 'react'

import './styles.scss'
import UserActivityAddToFavorites from 'app/domains/common/AddToFavorites/index'

const bc = 'activity-info'

const ActivityInfo = ({ activityId, highlightFavoriteIcon, description }) => (
  <div className={bc}>
    <p className={`${bc}__text`} dangerouslySetInnerHTML={{ __html: description }} />
    <UserActivityAddToFavorites activityId={activityId} highlightFavoriteIcon={highlightFavoriteIcon} />
  </div>
)

export default ActivityInfo
